export default "__VITE_ASSET__D1XxB6uO__"